export default {
  APP_NAME: "Amour",
};
